module.exports = __webpack_public_path__ + "static/media/rps4.88ccb1b1.gif";